<template>
  <section class="nav-bar">
    <!-- Navbar -->
    <nav
      class="main main-header navbar-white navbar-expand d-flex rounded-right flex-wrap"
      style="width: 100% !important"
      v-if="isLoggedIn"
    >
      <!-- Left navbar links -->
      <ul class="navbar-nav d-inline-flex flex-grow-1">
        <li
          class="nav-item d-sm-inline-block"
          @click="pushMenus(); isClicked();"
          id="togglebutton"
          v-bind="clicked"
        >
          <hamburger id="myHam"></hamburger>
          <!-- <a class="nav-link" @click="pushMenus(); isClicked();" id="togglebutton" v-model="clicked"><i
          class="fas fa-bars" style="color: rgb(0, 123, 255) !important; cursor: pointer;"></i></a>-->
        </li>
        <!-- SEARCH FORM -->
        <!-- <li class="nav-item d-none d-sm-inline-block d-inline-flex flex-row justify-content-end" style="padding: 0.3%">
        <form class="form-inline ml-3">
          <div class="input-group input-group-sm">
            <input class="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search">
            <div class="input-group-append">
              <button class="btn btn-navbar" type="submit">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </form>
        </li>-->

        <!-- Right navbar links -->

        <b-navbar-nav class="ml-auto">
          <h5 class="h5">
            <i class="fa fa-store"></i>
            {{$store.getters.empName}}
          </h5>
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template slot="button-content">
              <i class="fas fa-user"></i>
              {{$store.getters.usuario}} ({{rol}})
            </template>
            <b-dropdown-item class="w3-bar-item" @click="logOut()">
              <h5>
                {{$i18n.t('LogOut')}}
                <i class="fas fa-arrow-circle-right"></i>
              </h5>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item right>
          <select v-model="$i18n.locale" class="w3-select w3-border">
            <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
          </select>
          </b-nav-item>-->
        </b-navbar-nav>
        <!-- <li class="nav-item dropdown">
          <a class="nav-link colorUp correct" data-toggle="dropdown">
            <i class="fas fa-user" style="margin-block-start: 2px;">&nbsp;</i>
            {{$store.getters.usuario}}
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <a class="dropdown-item w3-bar-item letsHover2" @click="goToOut()">
              <h5>
                <b>
                  {{$i18n.t('LogOut')}}
                  <i class="fas fa-arrow-circle-left"></i>
                </b>
              </h5>
            </a>
          </div>
        </li>-->
        <!--
      <template slot="button-content"><img id="flags" :src="actualFlag" style="width: 25px; height: 20px;"
          v-model="flag"></img></template>
      <b-dropdown-item @click="changeLanguage('en')">En<img src="../../public/usa.png"
          style="width: 25px; height: 20px; float: right;"></img></b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('es')">Es<img src="../../public/arg.png"
          style="width: 25px; height: 20px; float: right;"></img></b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('pt')">Pt<img src="../../public/brazil.png"
          style="width: 25px; height: 20px; float: right;"></img></b-dropdown-item>
        </b-nav-item-dropdown>-->
      </ul>
    </nav>
    <!-- /.navbar -->

    <!-- Main Sidebar Container -->
    <!-- sidebar-dark-primary elevation-4 slider-vertical -->
    <aside
      class="main main-sidebar menu rounded-right"
      id="sidebar"
      data-widget="pushmenu"
      style="position: fixed; z-index: 1; height: 100%; width: 40px; max-width: 180px;"
      v-if="isLoggedIn"
    >
      <a class="brand-link">
        <img
          :src="getImagen180"
          id="logo"
          class="brand-image img-circle elevation-3"
          style="opacity: .8; width: 100%; height: 60px;"
        />
        <img
          :src="getImagen40"
          id="logoShort"
          class="brand-image img-circle elevation-3"
          style="opacity: .8; width: 100%; height: 40px;"
        />
        <!-- <span class="brand-text font-weight-light">AdminLTE 3</span> -->
      </a>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- Sidebar user panel (optional) -->
        <div class="user-panel d-flex">
          <div class="image">
            <!-- <i class="fas fa-user" v-if="!this.$store.getters.admin"></i><i class="fas fa-user-tie"
            v-if="this.$store.getters.admin"></i>-->
            <!-- <img src="dist/img/user2-160x160.jpg" class="img-circle elevation-2" alt="User Image"> -->
          </div>
          <!-- <div class="info">
          <a href="#" class="d-block">{{ userLogged }}</a>
          </div>-->
        </div>

        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
            <!-- Add icons to the links using the .nav-icon class
            with font-awesome or any other icon font library-->

            <menu-items :menu="config.menu" :clicked="clicked"></menu-items>
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
    </aside>

    <!-- **************** right config menu ********************* -->

    <div id="mainContent" style="margin: 1% 1% 1% 60px;">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
import $ from "jquery";
import Hamburger from "./hamburger.vue";
import menuItems from "./menu-items/index.vue";

// import Vue from 'vue';

export default {
  name: "nav-bar",
  components: {
    Hamburger,
    menuItems
  },
  props: {
    // <select v-model="$i18n.locale" class="w3-select w3-border">
    //         <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
    //       </select>
  },
  data() {
    return {
      rol: "",
      show: false,
      flag: "es",
      config: require("../config.json"),
      shown: 0,
      slided: false,
      clicked: 0,
      clicked2: 0
    };
  },
  async created() {
    let ws;
    await this.axios.get("./api/config").then(json => {
      ws = json.data;
      ws.max_file_size_mb = ws.max_file_size_mb * 1000000;
      this.$store.commit("setWs", ws);
      sessionStorage.setItem("ws",JSON.stringify(ws));
    });
    if (this.config && this.config.apiKeyYT) {
      this.$store.commit("setApiKeyYT", this.config.apiKeyYT);
      sessionStorage.setItem("apiKeyYT",this.config.apiKeyYT);
    }

    this.rol = sessionStorage.getItem("rol");

  },
  computed: {
    isLoggedIn: function() {
      return (
        this.$store.getters.usuario &&
        this.$store.getters.clave &&
        this.$store.getters.empId
      );
    },
    getImagen180() {
      if (this.config.image["180x60"] && this.config.image["180x60"] != "") {
        return this.config.image["180x60"];
      } else {
        return "https://via.placeholder.com/180x60";
      }
    },
    getImagen40() {
      if (this.config.image["40x40"] && this.config.image["40x40"] != "") {
        return this.config.image["40x40"];
      } else {
        return "https://via.placeholder.com/40x40";
      }
    }
  },
  methods: {
    letsShow(key) {
      if (this.clicked == 0) {
        switch (key) {
          case 1:
            this.shown = 1;
            break;
          case 2:
            this.shown = 2;
            break;
        }
        $(".myIcon").animate(
          {
            "margin-block-end": "0px",
            "padding-inline-start": "10px",
            "margin-block-start": "0px",
            "padding-top": "12px"
          },
          1
        );
      }
    },
    letsLeave(key) {
      if (this.clicked == 0) {
        switch (key) {
          case 1:
            this.shown = 0;
            break;
          case 2:
            this.shown = 0;
            break;
        }
        $(".myIcon").animate(
          {
            "padding-block-end": "10px",
            "padding-inline-start": "10px",
            "padding-block-start": "10px",
            "padding-top": "12px"
          },
          1
        );
      }
    },
    isClicked() {
      if (this.clicked == 1) {
        this.clicked = 0;
      } else {
        this.clicked = 1;
      }
    },
    isClicked2() {
      if (this.clicked2 == 1) {
        this.clicked2 = 0;
      } else {
        this.clicked2 = 1;
      }
    },
    pushControlBar() {
      if (this.clicked2 == 0) {
        $("#controlBar").css({ "pointer-events": "none", opacity: "0.6" });

        $("#controlSidebar").show();
        $("#controlSidebar").animate(
          {
            width: "250px"
          },
          350
        );

        setTimeout(() => {
          $("#controlBar").css({ "pointer-events": "auto", opacity: "1" });
        }, 500);
      } else if (this.clicked2 == 1) {
        $("#controlBar").css({ "pointer-events": "none", opacity: "0.6" });

        $("#controlSidebar").animate(
          {
            width: "0px"
          },
          350
        );

        setTimeout(() => {
          $("#controlSidebar").css({ display: "none" });
        }, 360);

        setTimeout(() => {
          $("#controlBar").css({ "pointer-events": "auto", opacity: "1" });
        }, 500);
      }
    },
    pushMenus() {
      // var slider = document.getElementById('sidebar').style.width;

      if (this.clicked == 0) {
        $("#togglebutton").css({ "pointer-events": "none", opacity: "0.6" });

        $("#logoShort").hide();
        $(".myIcon").animate(
          {
            "padding-block-end": "0px",
            "padding-inline-start": "10px",
            "padding-block-start": "0px",
            "padding-top": "2px",
            "margin-top": "10px"
          },
          1
        );
        $("#sidebar").animate(
          {
            width: "180px"
          },
          350
        );
        $("#mainContent").animate(
          {
            marginLeft: "200px"
          },
          350
        );
        $(".text").show();
        // setTimeout(() => {
        $("#logo").show();
        setTimeout(() => {
          $("#togglebutton").css({ "pointer-events": "auto", opacity: "1" });
        }, 500);
        // }, 350);
      } else if (this.clicked == 1) {
        $("#togglebutton").css({ "pointer-events": "none", opacity: "0.6" });

        // $('#logo').hide();
        setTimeout(() => {
          $("#logo").hide();
        }, 350);
        $(".myIcon").animate(
          {
            "margin-inline-start": "2px",
            "padding-block-end": "10px",
            "padding-inline-start": "10px",
            "padding-block-start": "10px",
            "padding-top": "12px",
            "margin-top": "0px"
          },
          1
        );
        $("#sidebar").animate(
          {
            width: "40px"
          },
          350
        );
        $("#mainContent").animate(
          {
            marginLeft: "60px"
          },
          350
        );
        $(".text").hide();
        setTimeout(() => {
          $("#logoShort").show();
        }, 370);
        setTimeout(() => {
          $("#togglebutton").css({ "pointer-events": "auto", opacity: "1" });
          // pointer-events:none;
          // opacity:0.6;
        }, 500);
      }

      // if ($(window).width() > 900) { //your chosen mobile res

      // if (slider == '180px') {
      //   $('#mainContent').animate({
      //     marginLeft: '15%'
      //   })
      // } else {
      //   $('#mainContent').animate({
      //     marginLeft: '4%'
      //   })
      // }
      // } else {
      //   $('#sidebar').animate({
      //     width: 'toggle'
      //   }, 350);
      // }
      // $('#sidebar').toggle();
      // $('[data-widget="pushmenu"]').toggle()
    },
    w3_open() {
      document.getElementById("main").style.marginLeft = "15%";
      document.getElementById("mySidebar").style.display = "block";
      document.getElementById("openNav").style.display = "none";
      $(document).ready(function() {
        $("#main").addClass("w3-opacity-max");
      });
    },
    w3_close() {
      document.getElementById("main").style.marginLeft = "0%";
      document.getElementById("mySidebar").style.display = "none";
      document.getElementById("openNav").style.display = "inline-block";
      document.getElementById("main").classList.remove("w3-opacity-max");
    },
    redirect(name) {
      this.$router.push({ name: name }).catch(() => {});
    },
    logOut() {
      this.$store.commit("setUser", undefined);
      this.$store.commit("setClave", undefined);
      this.$store.commit("setEmpId", undefined);
      let aux = JSON.parse(localStorage.grillaArticulos);
      aux.columns = JSON.parse(localStorage.grillaArticulos).columns.map(p => {
        if (p != undefined && (p.filterValue != undefined || p.filterValue)) {
          delete p.filterValue;
          return p;
        } else {
          return p;
        }
      });
      aux = JSON.stringify(aux);
      localStorage.setItem("grillaArticulos", aux);
      sessionStorage.clear();
      this.tooltip = !this.tooltip;
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style>
.main {
  background-color: rgb(38, 38, 38);
  /* border-end-end-radius: 2%; */
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.5);
  margin-left: 0%;
}

#logo {
  display: none;
  background-color: grey;
}
#logoShort {
  background-color: grey;
}
.correct {
  display: inline-flex;
  width: fit-content;
  margin-block-start: -2px;
  margin-inline-start: 10px;
}
.colorUp {
  /* width: 10%; */
  color: white !important;
  cursor: pointer;
}
.menu-derecha a {
  color: white;
}
.w3-bar-item a {
  color: black;
}

.myText {
  color: white !important;
  display: block;
  text-align: justify;
  width: max-content;
}

.sidenav {
  height: 100%;
  width: 160px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  /* padding-top: 20px; */
  transition: width 2s;
}

.sidenav a {
  padding: 0px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
}

.sidenav a:hover {
  color: #f1f1f1;
}

/* @media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 0px;
  }

  .sidenav a {
    font-size: 18px;
  }
} */

.blob {
  background: rgb(38, 38, 38);
  /* border-radius: 50%; */
  /* margin: 10px; */
  /* height: 1px;
  width: 1px; */

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  /* transform: scale(1); */
  animation: pulse 2s infinite;
}

.nav-item a {
  color: white !important;
}
@keyframes pulse {
  0% {
    /* transform: scale(0.95); */
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    /* transform: scale(1); */
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    /* transform: scale(0.95); */
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

/* ****************** animate *********************** */

/* .wrapper {
  width: 100%
}

.menu {
  background: #222;
  float: left;
  display: block;
}

.icon {
  max-width: 1em
} */
/*
.menu ul {
  list-style-type: none;
  margin: 0;
}

.menu li {
  margin: 0
}

.menu a,
.menu a:visited {
  color: white;
  text-decoration: none;
} */

.h5 {
  margin-top: 0.7rem;
  padding-right: 5px;
  color: white;
  border-right: 1px solid white;
  font-size: 14px !important;
}

.content {
  display: block;
}

.w3-bar-item a{
  color:black !important;
}
/* @media only screen and (max-width: 900px) {
  .text {
    display: none;
  }
} */

/* ANIMATE HAMBURGER MENU ICON */

/* .w3-button {
  border-radius: 4px !important;
}

.w3-button:hover {
  color: dodgerblue !important;
  background-color: #111 !important;
}

.w3-bar-item:hover {
  color: #111111;
}

.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.2s;
  padding-top: 60px;
}

.sidenav button {
  text-align: right;
  width: 100%;
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 15px;
  color: #f1f1f1;
  display: block;
  transition: 0.3s;
}

.sidenav button:hover {
  color: #111111;
  ;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

.notification {
  color: white;
  text-decoration: none;
  position: relative;
  display: inline-block;
  border-radius: 2px;
}

.notification .badge {
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 5px 10px;
  border-radius: 50%;
  background: dodgerblue;
  color: white;
}


@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }

  .sidenav a {
    font-size: 18px;
  }
} */

/* .blob {
  background: aquamarine; */
/* border-radius: 50%; */
/* margin: 10px; */
/* height: 1px;
  width: 1px; */

/* box-shadow: 0 0 0 0 rgba(0, 0, 0, 1); */
/* transform: scale(1); */
/* animation: pulse 2s infinite;
} */

/* @keyframes pulse {
  0% { */
/* transform: scale(0.95); */
/* box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  } */

/* 70% { */
/* transform: scale(1); */
/* box-shadow: 0 0 0 10px rgba(0, 0, 0, 0); */
/* } */

/* 100% { */
/* transform: scale(0.95); */
/* box-shadow: 0 0 0 0 rgba(0, 0, 0, 0); */
/* } */
/* } */

/* ********************************************* */
/* @import url("//maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

.navbar-icon-top .navbar-nav .nav-link > .fa {
  position: relative;
  width: 18px;
  font-size: 18px;
}

.navbar-icon-top .navbar-nav .nav-link > .fa > .badge {
  font-size: 0.75rem;
  position: absolute;
  right: 0;
  font-family: sans-serif;
}

.navbar-icon-top .navbar-nav .nav-link > .fa {
  top: 3px;
  line-height: 15px;
}

.navbar-icon-top .navbar-nav .nav-link > .fa > .badge {
  top: -1px;
  margin: -8px;
  right: -5px;
}

@media (min-width: 576px) {
  .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 24px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link > .fa {
    display: block;
    width: 24px;
    margin: 1px auto 2px auto;
    top: 0;
    line-height: 12px;
  }

  .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link > .fa > .badge {
    top: -1px;
    margin: -8px;
    right: -5px;
  }
}
@media (min-width: 768px) {
  .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 24px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link > .fa {
    display: block;
    width: 24px;
    margin: 1px auto 2px auto;
    top: 0;
    line-height: 12px;
  }

  .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link > .fa > .badge {
    top: -1px;
    margin: -8px;
    right: -5px;
  }
}

@media (min-width: 992px) {
  .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 24px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link > .fa {
    display: block;
    width: 24px;
    margin: 1px auto 2px auto;
    top: 0;
    line-height: 12px;
  }

  .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link > .fa > .badge {
    top: -1px;
    margin: -8px;
    right: -5px;
  }
}

@media (min-width: 1200px) {
  .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link {
    text-align: center;
    display: table-cell;
    height: 24px;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link > .fa {
    display: block;
    width: 24px;
    margin: 1px auto 2px auto;
    top: 0;
    line-height: 12px;
  }

  .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link > .fa > .badge {
    top: -1px;
    margin: -8px;
    right: -5px;
  }
} */

/* ************************************************ */
/* #loader {
        transition: all 0.3s ease-in-out;
        opacity: 1;
        visibility: visible;
        position: fixed;
        height: 100vh;
        width: 100%;
        background: #fff;
        z-index: 90000;
      }
      #loader.fadeOut {
        opacity: 0;
        visibility: hidden;
      }
      .spinner {
        width: 40px;
        height: 40px;
        position: absolute;
        top: calc(50% - 20px);
        left: calc(50% - 20px);
        background-color: #333;
        border-radius: 100%;
        -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
        animation: sk-scaleout 1.0s infinite ease-in-out;
      }
      @-webkit-keyframes sk-scaleout {
        0% { -webkit-transform: scale(0) }
        100% {
          -webkit-transform: scale(1.0);
          opacity: 0;
        }
      }
      @keyframes sk-scaleout {
        0% {
          -webkit-transform: scale(0);
          transform: scale(0);
        } 100% {
          -webkit-transform: scale(1.0);
          transform: scale(1.0);
          opacity: 0;
        }
      } */
</style>